import { useBunja } from 'bunja/react';
import { useRouter } from 'next/navigation';

import { useCheckSpotOnly } from '@flipster/features/src/shared/regulation';
import { FormattedMessage } from '@flipster/i18n';
import { createSegmentedControl } from '@flipster/react/design-system/segmented-control';
import { css } from '@flipster/styled-system/css';
import { hstack } from '@flipster/styled-system/patterns';

import { marketPageBunja } from '../state';

const ProductSegmentedControl = createSegmentedControl<'perpetual' | 'spot'>();

export const Title = () => {
  const router = useRouter();
  const { tab: marketTab } = useBunja(marketPageBunja);
  const isSpotOnly = useCheckSpotOnly();

  return (
    <div className={hstack({ px: { base: 16, tablet: 0 }, gap: 16, flexWrap: 'wrap' })}>
      <h1 className={css({ textStyle: 'Display/XL', color: 'inverse.white' })}>
        <FormattedMessage id='Navigation.r250401.Market' />
      </h1>
      {isSpotOnly && (
        <p
          className={css({
            flex: 1,
            minW: 0,
            textStyle: 'Body/XS/Regular',
            color: 'content.default.level-1',
          })}
        >
          <FormattedMessage id='Market.r260625.All_selections_usdt_paired_spot_for_vara' />
        </p>
      )}
      {!isSpotOnly && (
        <ProductSegmentedControl
          value={marketTab}
          onChange={(selectedTab) => {
            if (selectedTab === marketTab) return;
            router.replace(`/market/${selectedTab}`);
          }}
        >
          <ProductSegmentedControl.Item value='perpetual'>
            <FormattedMessage id='Assets.r250401.Perpetual' />
          </ProductSegmentedControl.Item>
          <ProductSegmentedControl.Item value='spot'>
            <FormattedMessage id='Assets.r250401.Spot' />
          </ProductSegmentedControl.Item>
        </ProductSegmentedControl>
      )}
    </div>
  );
};
